import { Inject, NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { BaseHrefProvider } from './base-href-provider';
import { InitialPathProvider, WEB_COMPONENT_INITIAL_PATH } from './initial-path-provider';
import { InitialRouteComponent } from './initial-route.component';

const routes: Routes = [
  {
    path: '**',
    component: InitialRouteComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
    }),
  ],
  exports: [
    RouterModule,
  ],
  providers: [
    BaseHrefProvider,
    InitialPathProvider,
  ],
})
export class WebComponentRoutingModule {
  public constructor(router: Router, @Inject(WEB_COMPONENT_INITIAL_PATH) initialPath: string) {
    router.initialNavigation();
    void router.navigateByUrl(initialPath);
  }
}
